<template>
  <div>
    <div class="bg-light-desktop pt-5">
      <div class="ga-container fluid">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-12 col-xl-8 mb-4">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-7 col-xl-7 mb-4">
                <template v-if="getMerchant().search_room_is_show_merchant_image">
                  <img :src="getMerchant().image_url" class="d-inline-block mb-2 mr-2 be_logo_vertical" v-if="logo == 'PORTRAIT'">
                  <img :src="getMerchant().image_url" class="d-inline-block mb-2 mr-2 be_logo_horizontal" v-else>
                </template>
                <p v-if="getMerchant().search_room_is_show_merchant_name" class="mb-2 body-2-2 font-bold text-30 d-inline-block">{{getMerchant().name}}</p>
                <div ref="desc" class="text-14 font-semibold body-2-2 pr-4 html-desc" :class="is_open ? '' : 'desc-min'" v-html="getMerchant().description"> 
                </div>
                <div class="mb-3 pb-2" v-if="desc_height > 210">
                  <span class="font-semibold body-2-2 text-14 underline cursor-pointer" v-if="!is_open" @click="togglePopUp('description')">{{$t("hotel.show-more")}}</span>
                  <!-- <span class="font-semibold body-2-2 text-14 underline cursor-pointer" v-else @click="isOpen()">{{$t("hotel.show-less")}}</span> -->
                </div>
                <div class="d-block" v-if="getMerchant().terms_and_conditions != ''">
                  <p class="mb-1 font-semibold text-16 d-inline-block cursor-pointer underline" @click="togglePopUp('term_condition')">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
                </div>
                <div class="d-block" v-if="getMerchant().cancellation_policy != ''">
                  <p class="mb-1 font-semibold text-16 d-inline-block cursor-pointer underline" @click="togglePopUp('order_policy')">{{$t('merchant.cancellation-policy')}}</p>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-5 col-xl-5">
                <p class="font-semibold text-20 mb-3">{{$t('general.contact-us')}}</p>
                <div class="d-block">
                  <img src="../../assets/img/icon/location.png" class="d-inline-block align-top mt-1" width="15">
                  <p class="font-regular text-14 d-inline-block ml-2 w-80">{{getMerchant().address}}</p>
                </div>
                <div class="d-block">
                  <img src="../../assets/img/icon/phone.png" class="d-inline-block align-top mt-1" width="15">
                  <p class="font-regular text-14 d-inline-block ml-2 w-80">Phone: 
                    <a :href="'tel:'+getMerchant().phone" target="_blank" class="color-black">
                      <span class="hover-link">{{getMerchant().phone}}</span>
                    </a>
                  </p>
                </div>
                <div class="d-block">
                  <img src="../../assets/img/icon/email.png" class="d-inline-block align-top mt-1 position-relative" style="top: 2px" width="15">
                  <p class="font-regular text-14 d-inline-block ml-2 w-80">Email: 
                    <a :href="'mailto:'+getMerchant().email" target="_blank" class="color-black">
                      <span class="hover-link">{{getMerchant().email}}</span>
                    </a>
                  </p>
                </div>
                <div class="mt-3" v-if="hasSocialMedia">
                  <p class="font-semibold text-20 mb-3">{{$t('general.social-media')}}</p>
                  <div class="d-inline-block mr-2 mb-2 footer-social-img" v-for="socmed in socialMediaList" :key="socmed.id">
                    <a :href="socmed.url" target="_blank" @click="handleSocialMediaClick(socmed)">
                      <img :src="socmed.imageUrl" :title="socmed.title" :alt="socmed.title" class="cursor-pointer social-icon" width="35" height="35">
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3" v-if="getMerchant().facilities.length > 0">
                <p class="font-semibold text-20 mb-3">{{$t('general.facilities')}}</p>
              </div>
              <div class="col-6 col-lg-4 col-xl-3" v-if="getMerchant().facilities.length > 0" v-for="data in getMerchant().facilities">
                <p class="mb-1 body-2-2 font-regular text-truncate"><img src="../../assets/img/icon/tick.png" width="14" class="mr-1">{{data.name}}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-12 col-xl-4">
            <div class="row no-gutters">
              <div class="col-12">
                <p class="font-semibold text-20 mb-3">{{$t('general.location')}}</p>
                <iframe v-if="$isNotEmptyV2(getMerchant().location_embed_map)" :src="getMerchant().location_embed_map" style="border:0;width: 100% !important; height: 250px !important;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="border-form box-shadow-none rounded-0"></iframe>
                <ShowGmaps v-else />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 bg-light-page">
        <div class="ga-container fluid">
          <div class="w-100 d-flex justify-content-between align-items-center w-100 py-3">
            <!-- <p class="font-regular text-14 mb-0 py-3">Powered by GuestPro  -->
            <p class="body-2-2 mb-0 hide-768px">Copyright © {{year.getFullYear()}} {{getMerchant().name}}</p>
            <p @click="toggleShowLanguagePopup(true)" class="body-2-1 mb-0 hide-768px">{{$t('hotel.language')}} | {{getCurrency().name}} ({{getCurrency().code}})</p>
            <p class="body-2-2 mb-0 show-768px">Copyright © {{year.getFullYear()}} {{getMerchant().name}}</p>
          </div> 
        </div>
      </div>
    </div>
    <GeneralLanguageCurrency :showPopup="showLanguagePopup" @togglePopup="toggleShowLanguagePopup" />
    <!-- Term & Conditions -->
    <!-- <template v-if="term_conditions">
      <transition name="fade">
        <div class="position-relative" style="z-index: 1049">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-8 position-relative">
                    <div class="rounded-4 bg-white p-4" style="overflow-y: scroll;height: 90vh;">
                      <img src="../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1038;right: 0" @click="term_conditions = false">
                      <div class="px-3">
                        <p class="font-semibold text-20 mb-3">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
                        <div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="getMerchant().terms_and_conditions"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template> -->
    <!-- Description, Term Condition, Order Policy -->
    <template v-if="popup">
      <transition name="fade">
        <div class="position-relative" style="z-index: 1049">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 col-lg-8 position-relative">
                    <div class="rounded-4 bg-white p-4 h-96vh" style="overflow-y: scroll;height: 90vh;">
                      <img src="../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1038;right: 0" @click="togglePopUp(false)">
                      <div class="px-3">
                        <template v-if="popup == 'description'">
                          <p class="font-semibold text-20 mb-3">{{$t('general.description')}}</p>
                          <div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="getMerchant().description"></div>
                        </template>
                        <template v-if="popup == 'term_condition'">
                          <p class="font-semibold text-20 mb-3">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
                          <div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="getMerchant().terms_and_conditions"></div>
                        </template>
                        <template v-if="popup == 'order_policy'">
                          <p class="font-semibold text-20 mb-3">{{$t('merchant.cancellation-policy')}}</p>
                          <div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="getMerchant().cancellation_policy"></div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <!-- Pop Up Backround -->
    <transition name="fade">
      <template v-if="popup || popup_active == 'cr_lang'">
        <div class="position-relative" :class="{'z-index-1042':popup_active == 'cr_lang'}" style="z-index: 1048">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="">
                      <div class="w-100 py-2 px-2" style="height: 100vh;background-color: #00000066">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>
<script>
  import PopUpBackgroundDesktop from '@/components/dev/PopUpBackgroundDesktop';
  import CurrencyAndLanguage from '@/components/hotel/be/desktop/CurrencyAndLanguage';
  import GeneralLanguageCurrency from '../general/GeneralLanguageCurrency.vue';
  import {mapGetters} from 'vuex';
  export default{
    components: {
      PopUpBackgroundDesktop,
      CurrencyAndLanguage,
      GeneralLanguageCurrency
    },
    props:{
      facilities:{
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        popup: false,
        description: false,
        order_policy: false,
        term_conditions: false,
        year: new Date(),
        popup_active: false,
        is_open: false,
        desc_height: 0,
        showLanguagePopup: false
      }
    },
    computed:{
      logo(){
        return this.getMerchant().image_orientation
      },
      socialMediaList(){
        const social_media = this.getMerchant().social_media || []
        return social_media
          .filter(item => this.$isNotEmptyV2(item.account_url))
          .map(item => ({
            id: item.id,
            type: item.type,
            title: this.$isNotEmptyV2(item.name) ? item.name : item.type,
            imageUrl: item.image_url,
            url: this.buildSocialMediaUrl(item.account_url)
          }))
      },
      hasSocialMedia(){
        return this.socialMediaList.length > 0
      }
    },
    mounted(){
      this.desc_height = this.$refs.desc.scrollHeight
    },
    methods: {
      ...mapGetters(['getMerchant','getCurrency']),
      toggleShowLanguagePopup(show=false){
        this.showLanguagePopup = show
      },
      togglePopUp(data){
        this.popup = data 
      },
      handlePopupFilter(data){
        this.popup_active = data
      },
      isOpen(){
        this.is_open = !this.is_open
      },
      buildSocialMediaUrl(url){
        const hasProtocol = url.startsWith('http://') || url.startsWith('https://')
        return hasProtocol ? url : 'https://' + url
      },
      handleSocialMediaClick(socmed){
        if(socmed.type == 'WHATSAPP'){
          this.$sendEventMetaConversionsAPI('Contact', 'whatsapp')
        }
      }
    }
  }
</script>
<style scoped>
  .social-icon{
    width: 35px;
    height: 35px;
    object-fit: cover;
    border-radius: 6px;
    transition: opacity .3s;
  }
  .footer-social-img:hover .social-icon{
    opacity: .7;
  }
  .desc-min{
    max-height: 210px;
    overflow: hidden;
  }
  @media screen and (max-width: 768px) {
    .footer .px-5{
      padding-left: 12px!important;
      padding-right: 12px!important;
    }
    .h-96vh{
      height: 96vh!important;
    }
    .footer-bottom{
      text-align: center;
      padding: 12px auto;
    }
    .footer-bottom span{
      display: block;
      margin-bottom: 6px;
    }
    .show-768px{
      display: block!important;
    }
    .hide-768px{
      display: none!important;
    }
    .footer-bottom .float-right{
      float: none!important;
    }
    .footer-bottom.bg-light-page{
      background-color: #f5f6f8!important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/Footer.vue